export default __webpack_public_path__ + "static/media/send.c7eea949.svg";